import type { PaletteDefinition } from "../../core/types";

export const genesisPalettes: Readonly<Record<string, PaletteDefinition>> = {
  "Lilikoi Sunset": {
    id: "lilikoi-sunset", primary: [244, 174, 72], secondary: [179, 69, 82], accent: [255, 226, 153],
  },
  "Hanalei Rain": {
    id: "hanalei-rain", primary: [58, 132, 128], secondary: [35, 74, 93], accent: [174, 214, 190],
  },
  Moonwater: {
    id: "moonwater", primary: [184, 207, 217], secondary: [73, 91, 121], accent: [238, 235, 221],
  },
  "Deep Current": {
    id: "deep-current", primary: [19, 68, 94], secondary: [6, 26, 45], accent: [55, 159, 167],
  },
  "Volcanic Dawn": {
    id: "volcanic-dawn", primary: [107, 43, 39], secondary: [28, 25, 29], accent: [225, 112, 54],
  },
};
